const featureFlags = {
  USE_GA4: false,
};

export default featureFlags;
